// extracted by mini-css-extract-plugin
export default {"container":"PathDistanceLabel_container__nKTOK"};